<template>
  <span
    v-b-tooltip.hover.right="{
      title: tooltip,
      disabled: !value,
    }"
    :class="`mc-status mc-status--${value ? 'green' : 'red'}`"
  >
    {{ label }}
  </span>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isOffline() {
      return String(this.item.featureNetworkMode).toLowerCase() === 'offline'
    },
    label() {
      if (!this.value) return this.$t('rjm.deviceSupportNo')

      return this.isOffline
        ? this.$t('rjm.deviceSupportNoInternet')
        : this.$t('rjm.deviceSupportInternetRequired')
    },
    tooltip() {
      return this.isOffline
        ? this.$t('rjm.deviceSupportNoInternetTooltip')
        : this.$t('rjm.deviceSupportInternetRequiredTooltip')
    },
  },
}
</script>
